export enum HistoryEntryType {
  NOTE = "NOTE",
  MESSAGE = "MESSAGE",
  ACTION = "ACTION",
  CARD = "CARD",
  USER = "USER",
  SYSTEM = "SYSTEM",
}
